/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationtabusers2Inputs */

const en_moderationtabusers2 = /** @type {(inputs: Moderationtabusers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User reports`)
};

const de_moderationtabusers2 = /** @type {(inputs: Moderationtabusers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzermeldungen`)
};

/**
* | output |
* | --- |
* | "User reports" |
*
* @param {Moderationtabusers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationtabusers2 = /** @type {((inputs?: Moderationtabusers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationtabusers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationtabusers2(inputs)
	return de_moderationtabusers2(inputs)
});
export { moderationtabusers2 as "moderationTabUsers" }